<template>
  <Toolbar classes="pt-3" />

  <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                      transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                <path
                  d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                  fill="black"></path>
              </svg>
            </span>
            <input type="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar..."
                   @input="fetchForms">
          </div>
        </div>
        <div class="card-toolbar">
          <button class="btn btn-primary" @click="newForm">
            Novo Formulário
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <div class="table-responsive">
          <table class="table table-hover table-row-bordered">
            <thead>
            <tr class="fw-bold fs-6 text-muted">
              <th>Nome</th>
              <th>Tipo de Consulta</th>
              <th>Enviar Antes</th>
              <th>Método de Envio</th>
              <th>Status</th>
              <th class="text-center">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="form in forms" :key="form.id_pre_schedule_form">
              <td class="d-flex align-items-center">
                <div class="d-flex flex-column">
                  <span class="text-gray-800 text-hover-primary mb-1">{{ form.form_name }}</span>
                  <span class="text-muted" v-if="form.form_description">{{ form.form_description }}</span>
                </div>
              </td>
              <td>{{ getScheduleTypeLabel(form.schedule_type) }}</td>
              <td>{{ form.send_before_hours }}h antes</td>
              <td>{{ getSendViaLabel(form.send_via) }}</td>
              <td>
                <span class="badge" :class="form.active ? 'badge-success' : 'badge-danger'">
                  {{ form.active ? 'Ativo' : 'Inativo' }}
                </span>
              </td>
              <td class="text-center" style="min-width: 125px;">
                <router-link
                  class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                  :to="'/pre-schedule-forms/' + form.id_pre_schedule_form + '/answers'"
                  title="Ver respostas">
                  <i class="bi bi-list-check"></i>
                </router-link>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="editForm(form)"
                        title="Editar formulário">
                  <i class="bi bi-pen"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="showFormQuestions(form)"
                        title="Gerenciar perguntas">
                  <i class="bi bi-question-circle"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="deleteForm(form)"
                        title="Apagar formulário">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="forms.length === 0">
              <td colspan="6" class="text-center text-muted py-5">
                Nenhum formulário encontrado
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <PreScheduleFormModal
      :form="selectedForm"
      @onClose="selectedForm = null"
      @formSaved="fetchForms()"
    />

    <PreScheduleFormQuestionModal
      :form="selectedForm"
      @onClose="selectedForm = null"
      @questionsUpdated="fetchForms()"
    />
  </div>
</template>

<script>
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import http from "../../helpers/http";
import Modal from "@/helpers/modal";
import Alert from "@/helpers/alert";
import PreScheduleFormModal from "./PreScheduleFormModal.vue";
import PreScheduleFormQuestionModal from "./PreScheduleFormQuestionModal.vue";

export default {
  name: "PreScheduleFormList",
  components: {
    PreScheduleFormQuestionModal,
    PreScheduleFormModal,
    Toolbar,
  },
  data() {
    return {
      search: '',
      selectedForm: null,
      forms: [],
    }
  },
  mounted() {
    this.fetchForms();
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  methods: {
    fetchForms() {
      this.forms = [];
      http.get(`/places/${this.place.id_place}/pre-schedule-forms`, {
        params: {
          'search': this.search,
        }
      }).then((response) => {
        this.forms = response.data;
      }).catch((e) => {
        Alert.error(e.response?.data?.message || 'Erro ao buscar formulários');
      });
    },
    newForm() {
      this.selectedForm = null;
      Modal.toggle('#preScheduleFormModal');
    },
    editForm(form) {
      this.selectedForm = form;
      Modal.toggle('#preScheduleFormModal');
    },
    showFormQuestions(form) {
      this.selectedForm = form;
      Modal.toggle('#preScheduleFormQuestionModal');
    },
    deleteForm(form) {
      Swal.fire({
        title: 'Atenção',
        text: "Tem certeza que deseja remover este formulário?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/pre-schedule-forms/${form.id_pre_schedule_form}`).then(() => {
            Alert.success('Formulário removido com sucesso.');
            this.fetchForms();
          }).catch((e) => {
            Alert.error(e.response?.data?.message || 'Erro ao remover formulário');
          });
        }
      });
    },
    getScheduleTypeLabel(type) {
      const labels = {
        'all': 'Todas',
        'NV': 'Nova Consulta',
        'RT': 'Retorno',
      };
      return labels[type] || type;
    },
    getSendViaLabel(via) {
      const labels = {
        'email': 'Email',
        'whatsapp': 'WhatsApp',
        'both': 'Email e WhatsApp',
      };
      return labels[via] || via;
    },
  }
}
</script>

<style scoped>

</style>
